import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import type { AppState } from '@nextgen-web-framework/core';
import { ProfileMapping, ProfileRole } from '@commerce-profile-webcomponents/sdk';
import { SliceConfigName } from '../../../utils/myAccountProfileUtils';
import { useMyAccount } from '../../../utils/myAccountHook';
import { parseString } from '../../../utils/helper';
import AccountInformation from '../../AccountInformation/AccountInformation';
import styles from './CoApplicantProfile.module.scss';

const CoApplicantProfile = () => {
  const { t, profileId: loginProfileId, getCoAppConfig, setConfig, fetchCoAppData, aboNum } = useMyAccount();
  const coAppConfig = getCoAppConfig();

  const registrationData = useSelector((state: AppState) => state.commerceProfile.registrationFlowData);
  const { userData } = registrationData;
  const { partnerAccounts } = userData;

  const [profileId, setProfileId] = useState<string>('');

  useEffect(() => {
    setConfig(coAppConfig);
    const profId = parseString(getProfileIdByLogin(partnerAccounts, loginProfileId));
    setProfileId(profId);
    fetchCoAppData(profId, aboNum);
  }, [partnerAccounts, loginProfileId]);

  const getProfileIdByLogin = (profiles: ProfileMapping[], currentProfileId: string) => {
    const profile = profiles?.find((profile: ProfileMapping) => profile?.profileId === currentProfileId);

    if (profile?.primary) {
      // return co-app account
      return profiles?.find((profile: ProfileMapping) => !profile?.primary && profile?.roleCode === ProfileRole.Owner)
        ?.profileId;
    } else {
      // return primary account
      return profiles?.find((profile: ProfileMapping) => profile?.primary)?.profileId;
    }
  };

  return (
    <div className={styles['co-app-profile-container']}>
      <AccountInformation
        masterDataConfig={coAppConfig}
        sliceName={SliceConfigName.CO_APP}
        profileId={profileId}
        accountNumber={aboNum}
        screenTitle={t('profile.coApp.screenTitle')}
        editButtonText={t('profile.coApp.button.edit')}
      />
    </div>
  );
};
export default CoApplicantProfile;
